<div class="progress-dialog">
  <mat-progress-spinner
    diameter="40"
    [mode]="preparing() ? 'indeterminate' : 'determinate'"
    [value]="preparing() ? 0 : percentage()"
  />
  <span>
    {{ progressText() | translate:{current: storeProgress(), total: storeTotal()} }}
  </span>
  <span>
    {{ 'TRANS__COPY_PROGRESS_DIALOG__DONT_CLOSE' | translate }}
  </span>
</div>
